module.exports = __webpack_public_path__ + "static/img/newHuaiC7.44baffc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/newHuaiC7.png
// module id = DTlC
// module chunks = 0